export const InProgressHeader = [
  { content: "Property" },
  { content: "Inncode" },
  { content: "Owners" },
  { content: "Plan Source" },
  { content: "Role Category" },
  { content: "Status" },
  { content: "Deadline" },
  { content: "Due Date" }
];

export const headers = [
  { content: "" },
  { content: "Property" },
  { content: "Customized" },
  { content: "Inncode" },
  { content: "Owners" },
  { content: "Plan Source" },
  { content: "Role Category" },
  { content: "Status" },
  { content: "Deadline" },
  { content: "Due Date" }
];
